/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleRightUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABBklEQVR4nO2SO05DQQxFhxroSMQKaGEFdE+KIL72FI4Nyk6yAtYQsYHsIDQRUCBKPhJsgYYG+qDhJSlAZCYSr0quNJ19juVxCGsdYrsk8UlHtdWMQHwC8SnYnxqRdFRbJPZYS+zlRHV/TSUUvSKxIYm/QuzzG7TkEdt9EVjEDkj8Ogf89djvsnCgdwyx99lEbxAbMJ8fVVV/+2dtjP02xJ5rgT10u2d72cnncLCPAOwu238602J4ymIt7KMQwlbR5xbDo1eLteDvyVPAdrUSvJ7ehrOmQa4WYhdgHxfDa0E6RZ+ext5hcdMqIfaPJFDVnUYE81tuBJ6yEWQDtlsSv8lXbhL+J183MbXwC08eSwAAAABJRU5ErkJggg==)
 */
export const ArrowAngleRightUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 7.3a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4-1.4L18.58 9H13a7 7 0 0 0-7 7v4a1 1 0 1 1-2 0v-4a9 9 0 0 1 9-9h5.59l-3.3-3.3a1 1 0 0 1 1.42-1.4l5 5Z"
        className={colorClass}
      />
    </svg>
  );
};
